import { ModalProps } from "../../interfaces/modal";
import { requestPasswordReset } from "../../api/login";
import { showToastError, showToastSuccess } from "../../services/toast";
import { useAuthStore } from "../../stores/auth";
import { Input } from "../ui/inputs/Input";
import LoadingSpinner from "../ui/LoadingSpinner";
import { useState } from "react";
import { ModalButton, ModalShell } from "../ui/modals/ModalShell";

const ResetPasswordModal: React.FC<ModalProps> = ({ closeModal }) => {
  const { email, setEmail, reset } = useAuthStore();
  const [isLoading, setIsLoading] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    requestPasswordReset(email)
      .then(() => {
        showToastSuccess("Email envoyé");
        setIsLoading(false);
        closeModal();
        reset();
      })
      .catch(() => {
        setIsLoading(false);
        showToastError("Erreur lors de l'envoi de l'email");
      });
  };

  return (
    <ModalShell
      title="Mot de passe oublié"
      subtitle="Nous vous enverrons un lien de réinitialisation."
      size="sm"
      onClose={() => closeModal()}
      footer={
        isLoading ? (
          <LoadingSpinner size="small" text="" />
        ) : (
          <>
            <ModalButton variant="secondary" onClick={() => closeModal()}>
              Annuler
            </ModalButton>
            <ModalButton variant="primary" onClick={handleSubmit}>
              Envoyer
            </ModalButton>
          </>
        )
      }
    >
      <form onSubmit={handleSubmit} className="font-Nunito">
        <Input
          key={"Email"}
          name={"Email"}
          label={"Email"}
          type={"email"}
          value={email}
          onChange={handleChange}
        />
      </form>
    </ModalShell>
  );
};

export default ResetPasswordModal;
